
import { BaseStrategy } from './BaseStrategy';

export class MA2Strategy extends BaseStrategy {
    constructor(keywordsData, monaco) {
        super(keywordsData, monaco, "MA2");
        this.version = "MA2";
        this.COMMON_OBJECTS = [
            "Cue", "Group", "Grp", "Preset", "Sequence", "Seq", "Fixture", "Fix",
            "Channel", "Chan", "Macro", "Mac", "Page", "World", "Executor", "Exec",
            "ExecButton1", "ExecButton2", "ExecButton3", "Plugin", "Layout",
            "At", "If", "Thru", "On", "Off"
        ];
    }

    getCompletionItems(model, position) {
        const context = this.analyzeContext(model, position);
        const { currentWord, isAtSpace, lastWord, words, range } = context;

        let suggestions = [];

        // 1. Variable suggestions
        const varSuggestions = this.getVariableSuggestions(context, model);
        if (varSuggestions.length > 0) return { suggestions: varSuggestions };

        // 2. Options suggestions
        const optSuggestions = this.getOptionSuggestions(context);
        if (optSuggestions.length > 0) return { suggestions: optSuggestions };

        // 3. Syntax-aware suggestions (Context focus)
        const syntaxSuggestions = this.getSyntaxSuggestions(context);
        if (syntaxSuggestions.length > 0) {
            suggestions.push(...syntaxSuggestions);
        }

        // 4. Assignment (=) after variable name
        if (isAtSpace && lastWord && lastWord.startsWith('$')) {
            if (lastWord.length > 1 && !this.VAR_KEYWORDS.some(k => k.toLowerCase() === lastWord.toLowerCase())) {
                suggestions.push({
                    label: "=",
                    kind: this.monaco.languages.CompletionItemKind.Operator,
                    insertText: "= ",
                    range: range,
                    command: this.TRIGGER_NEXT,
                    detail: "Assignment",
                    documentation: "Assign value to variable"
                });
            }
        }

        // 4. Helpers after Number
        if (isAtSpace && lastWord && /^\d+$/.test(lastWord)) {
            this.HELPERS.forEach(helper => {
                suggestions.push({
                    label: helper,
                    kind: this.monaco.languages.CompletionItemKind.Operator,
                    insertText: helper + " ",
                    range: range,
                    command: this.TRIGGER_NEXT,
                    detail: "Syntax Helper"
                });
            });
        }

        // 5. Common objects
        const isStartOfLine = words.length === 0 || (words.length === 1 && !isAtSpace);
        if (!isStartOfLine) {
            this.COMMON_OBJECTS.forEach(obj => {
                if (obj.toLowerCase().startsWith(currentWord)) {
                    suggestions.push({
                        label: obj,
                        kind: this.monaco.languages.CompletionItemKind.Class,
                        insertText: obj + " ",
                        range: range,
                        command: this.TRIGGER_NEXT,
                        detail: "Common Object (MA2)"
                    });
                }
            });
        }

        // 6. Keywords from Registry
        Object.entries(this.keywordsDict).forEach(([label, value]) => {
            const labelStr = label.toString();
            if (labelStr.toLowerCase().startsWith(currentWord) && !labelStr.startsWith('/') && !labelStr.startsWith('$')) {
                // Skip dirty labels
                if (labelStr.includes('[') && (labelStr.toLowerCase().includes('plus') || labelStr.toLowerCase().includes('minus'))) return;

                // Avoid duplicates
                if (suggestions.some(s => s.label === labelStr)) return;

                const desc = value?.description || '';
                const syntaxStr = Array.isArray(value?.syntax) ? value.syntax.join('\n') : (value?.syntax || '');

                suggestions.push({
                    label: labelStr,
                    kind: this.monaco.languages.CompletionItemKind.Keyword,
                    insertText: labelStr + " ",
                    range: range,
                    command: this.TRIGGER_NEXT,
                    documentation: {
                        value: `**${labelStr}**\n\n${desc}${syntaxStr ? `\n\n**Syntax:**\n\`\`\`\n${syntaxStr}\n\`\`\`` : ""}`
                    },
                });
            }
        });

        return { suggestions };
    }
}
